import CustomEvent from "custom-event";
import each from "lodash/each";
import { PopupModalModel } from "../models/PopupModalModel";

export const Highlights = () => {
  const sections = document.getElementsByClassName("highlight");
  if (!sections.length) return;

  each(sections, el => {
    modal(el);
    video(el);
  });
};

function modal(el: any): void {
  const modalContent = el.getElementsByClassName("highlight__modal");
  const modalBtn = el.getElementsByClassName("showModal");

  if (!modalContent.length || !modalBtn.length) return;

  modalBtn[0].addEventListener("click", e => {
    const content: PopupModalModel = { text: modalContent[0].innerHTML };
    const evt = new CustomEvent("showPopupModal", { detail: { content } });
    e.preventDefault();
    window.dispatchEvent(evt);
  });
}

function video(el: any): void {
  const videoWrap = el.getElementsByClassName("highlight__video");
  if (!videoWrap.length) return;

  const video = videoWrap[0].getElementsByClassName("highlight__videoItem");
  const btn = videoWrap[0].getElementsByClassName("highlight__playBtn");

  if (!video.length || !btn.length) return;

  btn[0].addEventListener("click", e => {
    video[0].play();
    video[0].setAttribute("controls", "true");
    btn[0].parentNode.removeChild(btn[0]);
  });
}
